import React, { useState, useEffect } from "react";
import { getDocs, doc,deleteDoc,setDoc,addDoc, collection,query, where, } from "firebase/firestore";
import { db } from "../../context/firebase";
import ModalComponent from "./ModalComponent";
import { Button, Typography, Grid } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
// import { addDoc, collection, doc } from 'firebase/firestore';

//components
import PageTitle from "../../components/PageTitle";

// styles
import useStyles from "./styles";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Actions = () => {
  var classes = useStyles();
  var disableUserList = [];

  const enableRef = collection(db, "enableusers");
  const disableRef = collection(db, "disableusers");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState("");
  const [action, setAction] = useState("enable");
  const [list, setList] = useState([]);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const TakeAction = () => {
    if (action === "disable") {
      addDoc(disableRef, {
        uid: data,
        status: "-1",
      })
        .then(() => {
          handleClose();
          addActions(data);
        })
        .catch(() => {
          alert("Cannot disable uid");
        });
          
    } else if (action === "enable") {
      addDoc(enableRef, {
        uid: data,
        status: "-1",
      })
        .then(() => {
          toast.success("✅ User Allowed!!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });

          handleClose();
          removeActions(data);
        })
        .catch(() => {
          alert("Cannot enable uid");
        });
    }
  };
  const addActions = async(uid) => {
    const q = query(collection(db, "users"), where("uid", "==", uid));

    const querySnapshot = await getDocs(q);
    var name,batch;

    querySnapshot.forEach((doc) => {
      name = doc.data().name;
      batch = doc.data().batch;
    });

    await setDoc(doc(db, "actions", `${uid}`), {
      uid: uid,
      name: name,
      batch: batch,
    }).then(() => {
      toast.success("⛔️ User Sucessfully Disabled!!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    
        handleClose()
    })
    .catch(() => {
        alert('Cannot add data')
    })
}
const removeActions=async(uid)=>{
  await deleteDoc(doc(db,"actions", `${uid}`));
}


  const fetchList = async () => {
    const data = await getDocs(collection(db, "actions"));

    data.docs.forEach((item) => {
      disableUserList.push([
        item.data().uid,
        item.data().name,
        item.data().batch,
        // item.data().name,
        // item.data().email,
        // item.data().contactNumber,
        // item.data().batch,
      ]);
    });
    setList(disableUserList);
  };
  useEffect(() => {
    fetchList();
  });

  return (
    <div>
      <PageTitle title="Actions against UID | Disabled Users" />

      <Grid container spacing={4} justify="center">
      <Typography variant="h2" className={classes.title}>
        {"Take Actions against any UID!"}
      </Typography>
      <Button
        className={classes.actionButton}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Take Action
      </Button>
      <ModalComponent
        open={open}
        setOpen={setOpen}
        setData={setData}
        setAction={setAction}
        action={action}
        TakeAction={TakeAction}
      />
        <Grid item xs={8}>
          <MUIDataTable
            title="Student List"
            data={list}
            columns={["UID", "Name","Batch"]}
            options={{
              filterType: "dropdown",
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Actions;
